










import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class TeamEngagementLabels extends Vue {
  @Prop() private color!: string
  @Prop() private value!: number
  @Prop() private label!: string
}
